import { computed } from '@ember/object';
import { attr } from '@ember-data/model';
import ALMOST_MAX_VALUE from '@square/dashboard-utilities/utils/math/almost-max-value';
import ItemsV3Base from '@square/dashboard-items-data/models/items-v3-base';
const MAX_NAME_LENGTH = 32;
export default ItemsV3Base.extend({
  name: attr('string'),
  ordinal: attr('number', {
    defaultValue: ALMOST_MAX_VALUE
  }),
  deletedOnModal: false,
  normalizedName: computed('name', function () {
    return (this.name || '').toUpperCase();
  }),
  rollbackAttributes() {
    this.set('deletedOnModal', false);
    this._super();
  }
}).reopenClass({
  MAX_NAME_LENGTH,
  sortKey: 'name',
  catalogType() {
    return 'DINING_OPTION';
  },
  _modelNameForMigration: 'dining-option'
});